export const tramites = [
    {
        "anio" : "Direccion General de Responsabilidades Administrativas",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    {
                        "nombre" : "Atención de Quejas y Denuncias",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/12640"
                    },
                    {
                        "nombre" : "Constancias de No Inhabilitación",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/13920"
                    },
                    {
                        "nombre" : "Inconformidades en Materia de Adquisiciones",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/13921"
                    },
                    {
                        "nombre" : "Inconformidades en Materia de Obra Pública",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/13919"
                    },
                    {
                        "nombre" : "Sistema de Declaración Patrimonial DeclaraNet",
                        "url" : "http://declaranet.hidalgo.gob.mx:5000/"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "Dirección General de Normatividad",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    // {
                    //     "nombre" : "Padrón de Proveedores",
                    //     "url" : "Tramite/Proveedores"
                    // },
                    // {
                    //     "nombre" : "Padrón de Contratistas",
                    //     "url" : "Tramite/Contratistas"
                    // },
                    
                    
                    
                    {
                        "nombre" : "Modificación en el Padrón de Proveedores Persona Física y Moral",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/12084"
                    },
                    {
                        "nombre" : "Revisión de Bases",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/12117"
                    },
                     {
                        "nombre" : "Inscripción en el Padrón de Contratistas Persona Física y Moral",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/12146"
                    },
                      {
                        "nombre" : "Modificación en el Padrón de Contratistas Persona Física y Moral",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/12147"
                    },
                        {
                        "nombre" : "Revalidación en el padrón de contratistas persona física y moral",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/12148"
                    },
                      {
                        "nombre" : "Distintivo de Integridad Empresarial",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/13995"
                    },
                    {
                        "nombre" : "Sistema de Registro de Proveedores y Contratistas",
                        "url" : "https://srpcehcontraloria.hidalgo.gob.mx/rext/"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "Dirección General de Vinculación",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    {
                        "nombre" : "Asesoría y Capacitación en Materia de Contraloría Social",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/14444"
                    },
                    {
                        "nombre" : "Fortalecimiento de valores y cultura a la legalidad para niños y niñas",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/14466"
                    },
                    {
                        "nombre" : "Recepción y Seguimiento de Quejas, Denuncias y Solicitudes de Contraloría Social",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/14468"
                    }
                ]
            },

            {
                "nombre" : "Contraloría Social ",
                "contenidoTramite" : [
                    {
                        "nombre" : "Aviso de privacidad",
                        "url" : "https://ruts.hidalgo.gob.mx/ver/426"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "Dirección General de Auditoría Gubernamental",
        "tramitesLista" : [
            {
                "nombre" : "Servicios",
                "contenidoTramite" : [
                    {
                        "nombre" : "Quejas de Obra Pública",
                        "url" : "https://ruts20.hidalgo.gob.mx/informacion/14106"
                    }
                ]
            }
        ]
    }
]